<template>
  <div>
    <AddQuestions />
  </div>
</template>
<script>
import AddQuestions from '../../../components/skillup/packages/AddQuestions.vue'
export default {
  name: 'skillUp-question-packages',
  components: { AddQuestions },
}
</script>
